import React, { Fragment } from 'react';

export class LinkedInImporterPrivacy extends React.Component {
	render() {
		return (
			<Fragment>
				<div className="container document">
					<section className="hero is-light header">
						<div className="hero-body">
							<div className="container has-text-centered">
								<img alt="Privacy Policy" src="/legalIcon.svg" />
								<h1 className="title has-text-light add-lg-margin-top">
									Privacy Policy
								</h1>
								<label className="subtitle is-6 has-text-light">
									LinkedIn Importer for ATS
								</label>
								<label className="subtitle is-7 has-text-light">
									Last Updated: January 28, 2026
								</label>
							</div>
						</div>
					</section>

					<div className="section">
						{/* Introduction */}
						<div className="section content">
							<span className="title is-5">1. Introduction</span>
							<br />
							<br />
							<p>
								LinkedIn Importer for ATS ("the Extension", "we", "our", or
								"us") is committed to protecting your privacy. This Privacy
								Policy explains how our Chrome extension collects, uses, and
								safeguards information when you use our service.
							</p>
							<br />
							<p>
								<strong>Our Core Privacy Principle:</strong> The Extension
								transfers data directly from LinkedIn to your browser without
								sending any information to external servers. We do not collect,
								store, or share your personal data with any third parties.
							</p>
						</div>

						{/* What Data is Collected */}
						<div className="section content">
							<span className="title is-5">2. Information We Collect</span>
							<br />
							<br />
							<span className="title is-6">2.1 Profile Data from LinkedIn</span>
							<br />
							<p>
								When you actively click the "Import to ATS" button, the
								Extension extracts the following information from the LinkedIn
								profile page you are viewing:
							</p>
							<ul>
								<li>
									<strong>Full Name</strong> - The candidate's name as displayed
									on their profile
								</li>
								<li>
									<strong>Email Address</strong> - Contact email if visible on
									the profile
								</li>
								<li>
									<strong>Phone Number</strong> - Contact phone if visible on
									the profile
								</li>
								<li>
									<strong>Professional Headline</strong> - Job title and
									professional summary
								</li>
								<li>
									<strong>Current Company</strong> - Current employer
									information
								</li>
								<li>
									<strong>Location</strong> - City and country as shown on the
									profile
								</li>
								<li>
									<strong>Profile Photo URL</strong> - Link to the publicly
									visible profile picture
								</li>
								<li>
									<strong>LinkedIn Profile URL</strong> - The URL of the profile
									being viewed
								</li>
							</ul>
							<br />
							<p>
								<strong>Important:</strong> The Extension only accesses publicly
								visible information that is already displayed on the LinkedIn
								profile page. It does NOT access:
							</p>
							<ul>
								<li>Private messages or conversations</li>
								<li>Your connections list or network data</li>
								<li>Full employment history or education details</li>
								<li>Posts, activity feed, or engagement data</li>
								<li>Premium LinkedIn features or restricted content</li>
							</ul>
							<br />

							<span className="title is-6">2.2 Local Storage Data</span>
							<br />
							<p>
								The Extension stores the following preferences locally on your
								device using Chrome's storage API:
							</p>
							<ul>
								<li>
									<strong>Cache Settings</strong> - Your preference for
									enabling/disabling profile caching
								</li>
								<li>
									<strong>Extension Configuration</strong> - Settings for your
									ATS integration
								</li>
							</ul>
							<p>
								This data is stored exclusively on your device and is never
								transmitted to our servers or any third party.
							</p>
						</div>

						{/* How We Use Data */}
						<div className="section content">
							<span className="title is-5">3. How We Use Your Information</span>
							<br />
							<br />
							<span className="title is-6">3.1 Primary Purpose</span>
							<br />
							<p>
								The extracted profile data is used <strong>exclusively</strong>{' '}
								to:
							</p>
							<ul>
								<li>
									Pre-fill your ATS (Applicant Tracking System) candidate form
								</li>
								<li>Reduce manual data entry for recruiters</li>
								<li>Transfer information directly within your browser</li>
							</ul>
							<br />

							<span className="title is-6">3.2 Data Transfer Process</span>
							<br />
							<p>When you import a profile:</p>
							<ol>
								<li>You click "Import to ATS" on a LinkedIn profile</li>
								<li>
									The Extension extracts publicly visible data from the page DOM
								</li>
								<li>A secure browser tab opens with your ATS candidate form</li>
								<li>
									Data is transferred directly to the form using browser APIs
								</li>
								<li>
									You review the information and manually submit to your ATS
								</li>
							</ol>
							<br />
							<p>
								<strong>Critical Note:</strong> No data is sent to external
								servers during this process. The transfer happens entirely
								within your browser using secure communication channels.
							</p>
						</div>

						{/* Data Sharing */}
						<div className="section content">
							<span className="title is-5">
								4. Data Sharing and Third Parties
							</span>
							<br />
							<br />
							<span className="title is-6">4.1 No Third-Party Sharing</span>
							<br />
							<p>
								<strong>
									We do NOT sell, rent, trade, or share your data with any third
									parties.
								</strong>
							</p>
							<br />
							<p>The Extension transfers data exclusively between:</p>
							<ul>
								<li>
									<strong>Source:</strong> The LinkedIn profile page in your
									browser
								</li>
								<li>
									<strong>Destination:</strong> Your organization's ATS
									application in your browser
								</li>
							</ul>
							<br />

							<span className="title is-6">4.2 Your ATS System</span>
							<br />
							<p>
								When you submit the pre-filled form in your ATS, the data
								becomes subject to your organization's ATS privacy policy and
								data handling practices. We are not responsible for how your
								organization's ATS stores or processes the submitted
								information.
							</p>
							<br />

							<span className="title is-6">4.3 No Analytics or Tracking</span>
							<br />
							<p>The Extension does NOT use:</p>
							<ul>
								<li>Analytics services (e.g., Google Analytics)</li>
								<li>Tracking pixels or cookies</li>
								<li>Telemetry or usage monitoring</li>
								<li>Error reporting services</li>
								<li>Advertising networks</li>
							</ul>
						</div>

						{/* Data Security */}
						<div className="section content">
							<span className="title is-5">5. Data Security</span>
							<br />
							<br />
							<p>
								We implement multiple security measures to protect data during
								transfer:
							</p>
							<br />

							<span className="title is-6">
								5.1 Cryptographic Nonce Verification
							</span>
							<br />
							<p>
								Each import generates a unique, single-use cryptographic token
								(nonce) to ensure that only authorized transfers are accepted by
								your ATS form.
							</p>
							<br />

							<span className="title is-6">5.2 Origin Validation</span>
							<br />
							<p>
								The Extension validates that data transfers only occur between
								authorized domains (LinkedIn and your configured ATS URL).
							</p>
							<br />

							<span className="title is-6">5.3 HTTPS-Only Communication</span>
							<br />
							<p>
								All data transfers require HTTPS connections to prevent
								man-in-the-middle attacks.
							</p>
							<br />

							<span className="title is-6">5.4 No Persistent Storage</span>
							<br />
							<p>
								Profile data is not permanently stored. It exists only
								temporarily during the import process and is immediately
								discarded after transfer.
							</p>
						</div>

						{/* User Rights */}
						<div className="section content">
							<span className="title is-5">6. Your Rights and Control</span>
							<br />
							<br />
							<span className="title is-6">6.1 User Control</span>
							<br />
							<p>You have complete control over the Extension:</p>
							<ul>
								<li>
									<strong>Opt-in Only:</strong> The Extension only extracts data
									when you explicitly click "Import to ATS"
								</li>
								<li>
									<strong>Manual Submission:</strong> You review all data before
									submitting to your ATS
								</li>
								<li>
									<strong>Uninstall Anytime:</strong> You can remove the
									Extension at any time from Chrome settings
								</li>
								<li>
									<strong>Clear Storage:</strong> You can clear all Extension
									settings through Chrome's extension management
								</li>
							</ul>
							<br />

							<span className="title is-6">6.2 No Account or Registration</span>
							<br />
							<p>
								The Extension does not require you to create an account or
								register. There is no user database or authentication system.
							</p>
						</div>

						{/* Chrome Permissions */}
						<div className="section content">
							<span className="title is-5">
								7. Chrome Permissions Explained
							</span>
							<br />
							<br />
							<p>The Extension requests the following Chrome permissions:</p>
							<br />

							<table className="table is-bordered is-striped is-fullwidth">
								<thead>
									<tr>
										<th>Permission</th>
										<th>Purpose</th>
										<th>Scope</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<strong>activeTab</strong>
										</td>
										<td>
											Access the current LinkedIn profile page to read publicly
											visible information
										</td>
										<td>Only when you click the Extension icon</td>
									</tr>
									<tr>
										<td>
											<strong>storage</strong>
										</td>
										<td>
											Save your preferences (like cache settings) locally on
											your device
										</td>
										<td>Local device only, no cloud sync</td>
									</tr>
									<tr>
										<td>
											<strong>scripting</strong>
										</td>
										<td>
											Inject secure communication bridge into your ATS page for
											data transfer
										</td>
										<td>Only your configured ATS domain</td>
									</tr>
									<tr>
										<td>
											<strong>linkedin.com</strong>
										</td>
										<td>Extract profile information from LinkedIn pages</td>
										<td>Only profile pages (/in/*)</td>
									</tr>
									<tr>
										<td>
											<strong>Your ATS Domain</strong>
										</td>
										<td>
											Communicate with your organization's ATS to pre-fill forms
										</td>
										<td>Only your configured ATS URL</td>
									</tr>
								</tbody>
							</table>
						</div>

						{/* Children's Privacy */}
						<div className="section content">
							<span className="title is-5">8. Children's Privacy</span>
							<br />
							<br />
							<p>
								The Extension is designed for use by recruiters and HR
								professionals in a business context. It is not intended for use
								by individuals under the age of 18. We do not knowingly collect
								information from children.
							</p>
						</div>

						{/* GDPR Compliance */}
						<div className="section content">
							<span className="title is-5">9. GDPR and Data Protection</span>
							<br />
							<br />
							<span className="title is-6">9.1 Legal Basis for Processing</span>
							<br />
							<p>Under GDPR, our legal basis for processing is:</p>
							<ul>
								<li>
									<strong>Legitimate Interest:</strong> Facilitating recruitment
									workflows by reducing manual data entry
								</li>
								<li>
									<strong>Explicit Consent:</strong> Users actively initiate
									each data extraction by clicking "Import to ATS"
								</li>
							</ul>
							<br />

							<span className="title is-6">9.2 Data Controller</span>
							<br />
							<p>
								Your organization (the ATS owner) is the data controller for any
								candidate information submitted to the ATS. The Extension acts
								as a data processor only during the brief transfer period.
							</p>
							<br />

							<span className="title is-6">9.3 Data Retention</span>
							<br />
							<p>
								The Extension does not retain profile data. Temporary data used
								during transfer is automatically deleted after 60 seconds or
								upon successful transfer, whichever comes first.
							</p>
						</div>

						{/* Changes to Policy */}
						<div className="section content">
							<span className="title is-5">
								10. Changes to This Privacy Policy
							</span>
							<br />
							<br />
							<p>
								We may update this Privacy Policy from time to time to reflect
								changes in our practices or for legal, operational, or
								regulatory reasons. When we make changes:
							</p>
							<ul>
								<li>
									We will update the "Last Updated" date at the top of this
									policy
								</li>
								<li>
									Material changes will be communicated through the Extension or
									Chrome Web Store listing
								</li>
								<li>
									Continued use of the Extension after changes constitutes
									acceptance of the updated policy
								</li>
							</ul>
						</div>

						{/* Contact */}
						<div className="section content">
							<span className="title is-5">11. Contact Us</span>
							<br />
							<br />
							<p>
								If you have questions, concerns, or requests regarding this
								Privacy Policy or our data practices, please contact us:
							</p>
							<br />
							<div className="box">
								<p>
									<strong>Email:</strong> privacy@prediktive.com
								</p>
								<p>
									<strong>Website:</strong> https://www.talent.prediktive.com
								</p>
								<p>
									<strong>Address:</strong> Prediktive Technology Services
								</p>
							</div>
						</div>

						{/* Summary */}
						<div className="section content">
							<div className="notification is-info">
								<span className="title is-6">Summary</span>
								<br />
								<br />
								<ul>
									<li>
										✓ The Extension only extracts publicly visible LinkedIn
										profile information
									</li>
									<li>
										✓ Data is transferred directly to your ATS within your
										browser
									</li>
									<li>
										✓ No data is sent to external servers or third parties
									</li>
									<li>✓ No analytics, tracking, or telemetry</li>
									<li>
										✓ You have full control - import is always manual and opt-in
									</li>
									<li>
										✓ Local preferences only - no user accounts or registration
									</li>
									<li>✓ GDPR compliant with no persistent data retention</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}
